const template = document.createElement("template");
template.innerHTML = `
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/wc-datepicker/dist/themes/light.css">

<style>
  .wc-datepicker {
    border: 0;
    color: var(--color-button-text);
    /** Custom Freud start **/
    font-size: 1.22rem;
    max-width: 28rem;
    /** Custom Freud end **/
    width: 100%;
  }

  .wc-datepicker__header {
    padding: 0;
    padding-block: 0.75rem;
  }

  .wc-datepicker__body {
    padding-right: 0;
    padding-left: 0;
  }

  .wc-datepicker__previous-month-button,
  .wc-datepicker__next-month-button {
    background: transparent;
    border: 1px solid;
    border-radius: var(--inputs-radius);
    height: 3rem;
    width: 3rem;
  }

  .wc-datepicker__month-select,
  .wc-datepicker__year-select {
    background: transparent;
    border: 1px solid;
    border-radius: var(--inputs-radius);
    height: 3rem;
  }

  .wc-datepicker__year-select {
    max-width: unset;
  }

  .wc-datepicker__date--disabled {
    text-decoration: line-through;
  }
</style>

<wc-datepicker first-day-of-week="1"></wc-datepicker>
`;

class DatePickerSetup extends HTMLElement {
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));

    // stores for elm data
    this._slotDates = [];
    this._error = "";
    this._dateValue = "";

    // third party component
    this._datePicker = this._shadowRoot.querySelector("wc-datepicker");

    // send date value back to elm
    this._datePicker.addEventListener("selectDate", () => {
      this.dispatchValue();
    });
  }

  get dateValue() {
    return this._dateValue;
  }

  set dateValue(value) {
    if (this._dateValue === value) return;
    this._dateValue = value;
    this._datePicker.value = this._dateValue;
  }

  get error() {
    return this._error;
  }

  set error(value) {
    if (this._error === value) return;
    this._error = value;
    this._datePicker.error = this._error;
  }

  get slotDates() {
    return this._slotDates;
  }

  set slotDates(value) {
    if (this._slotDates === value) return;
    this._slotDates = value;

    // update disabled date function
    const dateStrings = this._slotDates.map((d) =>
      new Date(d).toLocaleDateString(),
    );
    const available = this.inDates(dateStrings);
    this._datePicker.disableDate = (date) => !available(date);
  }

  inDates(dates) {
    return (date) => dates.includes(date.toLocaleDateString());
  }

  formatDate(datepickerDate) {
    const date = new Date(datepickerDate);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  dispatchValue() {
    this._dateValue = this.formatDate(this._datePicker.value);
    this.dispatchEvent(new CustomEvent("dateChanged"));
  }
}

customElements.define("date-picker-setup", DatePickerSetup);
